import { Box, Loader } from 'braid-design-system';

export const LoadableFallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    padding="xxlarge"
    background="surface"
  >
    <Loader />
  </Box>
);
